import { render, staticRenderFns } from "./PortalOfficeSearchBox.vue?vue&type=template&id=6d3cb405&scoped=true&"
import script from "./PortalOfficeSearchBox.vue?vue&type=script&lang=ts&"
export * from "./PortalOfficeSearchBox.vue?vue&type=script&lang=ts&"
import style0 from "./PortalOfficeSearchBox.vue?vue&type=style&index=0&id=6d3cb405&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cb405",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VCol,VListItem,VListItemContent,VListItemTitle,VRow,VSelect})
